import * as React from "react";
function SvgChartDown(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3 5.5a.5.5 0 111 0v1.245l4.986 3.626 2.202-1.761.306-.245.31.239 6.5 5a.5.5 0 01-.609.792l-6.189-4.76-2.194 1.754-.298.239-.308-.225L4 7.982V18h16.5a.5.5 0 110 1h-17a.5.5 0 01-.5-.5V7.006 5.5zm17 6a.5.5 0 10-1 0V15h-3.5a.5.5 0 000 1H20v-4.5z" /></svg>;
}
const ForwardRef = React.forwardRef(SvgChartDown);
export default ForwardRef;